<p-progressSpinner *ngIf="spinner" class="spinner_in_front"></p-progressSpinner>
<div class="ps-3 pe-3">
  <div class="d-flex flex-row justify-content-between pb-2">
    <div class="d-flex flex-row">
      <img class="edit_employee_profile_picture" (click)="cropAndCompressImageDialog()"
           [src]="!addOrEditMenuItemModel.pictureURL? imagePath : addOrEditMenuItemModel.pictureURL "
           alt="profile-picture">
      <div class="picture-edit align-self-center">
        <p class="hide_mobile primary_medium_text_16 m-0">
          {{ 'MENU_ITEM.UPLOAD_IMAGE_MESSAGE' | translate }}
          <label *ngIf="pictureIsWrongFormat">
            <i class="pi pi-exclamation-circle me-1 error_color wrong_format_tooltip"
               pTooltip="{{'MENU_ITEM.WRONG_FORMAT' | translate}}" tooltipPosition="top"></i>
          </label>
          <label *ngIf="errorModel!=null && errorModel['Image']!=null">
            <i class="pi pi-exclamation-circle me-1 error_color wrong_format_tooltip"
               pTooltip="{{ errorModel['Image'] | translate }}" tooltipPosition="top"></i>
          </label>
        </p>
        <p class="show_mobile primary_medium_text_16 m-0">
          {{ 'MENU_ITEM.UPLOAD_IMAGE_MESSAGE_MOBILE' | translate }}
          <label *ngIf="pictureIsWrongFormat">
            <i class="pi pi-exclamation-circle me-1 error_color wrong_format_tooltip"
               pTooltip="{{'MENU_ITEM.WRONG_FORMAT' | translate}}" tooltipPosition="top"></i>
          </label>
          <label *ngIf="errorModel!=null && errorModel['Image']!=null">
            <i class="pi pi-exclamation-circle me-1 error_color wrong_format_tooltip"
               pTooltip="{{ errorModel['Image'] | translate }}" tooltipPosition="top"></i>
          </label>
        </p>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12 col-sm-6 p-b-10-mbl">
      <label class="lbl_pos_field">{{'MENU_ITEM.NAME' | translate}}
        <i *ngIf="errorModel!=null && errorModel['Name']!=null"
           class="pi pi-exclamation-circle me-1 mt-1 error_color float-end"
           pTooltip="{{errorModel['Name']|translate}}" tooltipPosition="top"></i>
      </label>
      <input type="text" class="primary_input_field" [(ngModel)]="addOrEditMenuItemModel.name">
    </div>
    <div class="col-12 col-sm-6 row p-b-10-mbl">
      <div class="col-6">
        <label class="lbl_pos_field"
               [ngStyle]="errorModel!=null && errorModel['Price']!=null ? {'font-size': '0.9rem'} : {}">{{'MENU_ITEM.PRICE_WITHOUT_TAX' | translate}}
          <i *ngIf="errorModel!=null && errorModel['Price']!=null"
             class="pi pi-exclamation-circle me-1 mt-1 error_color float-end"
             pTooltip="{{errorModel['Price']|translate}}" tooltipPosition="top"></i>
        </label>
        <input type="number" step=".01" min="0" class="primary_input_field"
               [(ngModel)]="addOrEditMenuItemModel.price">
      </div>
      <div class="col-6 ">
        <label class="w-65-mbl lbl_pos_field">{{'MENU_ITEM.ADD_TAX' | translate}}
          <i *ngIf="errorModel!=null && errorModel['Tax']!=null"
             class="pi pi-exclamation-circle me-1 mt-1 error_color float-end"
             pTooltip="{{errorModel['Tax']|translate}}" tooltipPosition="top"></i>
        </label>
        <p-dropdown  *ngIf="addOrEditMenuItemModel.taxRateId"  class="pos_dropdown" [options]="taxRatesDropdownHelperModels"
                    [(ngModel)]="addOrEditMenuItemModel.taxRateId" optionLabel="name" optionValue="id"
                    placeholder="{{'MENU_ITEM.SELECT_TAX' | translate}}"></p-dropdown>
      </div>
    </div>
    <div class="col-12 col-sm-6 p-b-10-mbl">
      <label class="lbl_pos_field">{{'MENU_ITEM.ADD_TO_CATEGORY' | translate}}
        <i *ngIf="errorModel!=null && errorModel['CategoryId']!=null"
           class="pi pi-exclamation-circle me-1 mt-1 error_color float-end"
           pTooltip="{{errorModel['CategoryId']|translate}}" tooltipPosition="top"></i>
      </label>
      <p-dropdown class="pos_dropdown" [options]="categoriesDropdownHelperModels"
                  (onChange)="reloadSubcategories($event)" [(ngModel)]="addOrEditMenuItemModel.categoryId"
                  optionLabel="name" optionValue="id"
                  placeholder="{{'MENU_ITEM.SELECT_CATEGORY' | translate}}"></p-dropdown>
    </div>
    <div class="col-12 col-sm-6 p-b-10-mbl">
      <label class="lbl_pos_field">{{'MENU_ITEM.ADD_TO_SUBCATEGORY' | translate}}
        <i *ngIf="errorModel!=null && errorModel['SubcategoryId']!=null"
           class="pi pi-exclamation-circle me-1 mt-1 error_color float-end"
           pTooltip="{{errorModel['SubcategoryId']|translate}}" tooltipPosition="top"></i>
      </label>
      <p-dropdown class="pos_dropdown" [options]="subcategoriesDropdownHelperModels"
                  [(ngModel)]="addOrEditMenuItemModel.subcategoryId" optionLabel="name" optionValue="id"
                  placeholder="{{'MENU_ITEM.SELECT_SUBCATEGORY' | translate}}"></p-dropdown>
    </div>
    <div class="col-12 col-sm-6 p-b-10-mbl">
      <label class="lbl_pos_field">{{'MENU_ITEM.DIVISIONS' | translate}}
        <i *ngIf="errorModel!=null && errorModel['SubvenueIds']!=null"
           class="pi pi-exclamation-circle me-1 mt-1 error_color float-end"
           pTooltip="{{errorModel['SubvenueIds']|translate}}" tooltipPosition="top"></i>
      </label>
      <p-multiSelect id="myltiSelectId" class="pos_dropdown menu-item-division-multiselect"
                     [options]="divisionsDropdownHelper" [(ngModel)]="addOrEditMenuItemModel.subvenueIds"
                     optionLabel="name"
                     optionValue="id" [showHeader]="false" [maxSelectedLabels]="4" [virtualScroll]="true"
                     placeholder="{{'MENU_ITEM.SELECT_DIVISIONS' | translate}}">
      </p-multiSelect>
    </div>
    <div class="col-12">
      <label class="lbl_pos_field w-25">{{'MENU_ITEM.DESCRIPTION' | translate}}</label>
      <label class="lbl_pos_field text-end float-end w-25" *ngIf="addOrEditMenuItemModel.description">
        {{255 - addOrEditMenuItemModel.description.length}}/255</label>
      <textarea rows="4" cols="50" class=" dsc_text_area" maxlength="255"
                [(ngModel)]="addOrEditMenuItemModel.description"></textarea>
    </div>
  </div>

  <div *ngIf="addOrEditMenuItemModel.supplies">
    <div class="row col-12 p-b-10-mbl">
      <div class="col-6">
        <label class="w-65-mbl lbl_pos_field">{{'MENU_ITEM.INGREDIENTS' | translate}}
          <i *ngIf="errorModel!=null && errorModel['Supplies']!=null"
             class="pi pi-exclamation-circle me-1 mt-1 error_color float-end"
             pTooltip="{{errorModel['Supplies']|translate}}" tooltipPosition="top"></i>
        </label>
      </div>
      <div class="col-12 col-sm-6 row p-b-10-mbl">
        <div class="col-4">
          <label class="w-65-mbl lbl_pos_field">{{'MENU_ITEM.QUANTITY' | translate}}</label>
        </div>
        <div class="col-4">
          <label class="w-65-mbl lbl_pos_field text-wrap">{{'INGREDIENT_ITEM.UNIT' | translate}}</label>
        </div>
        <div class="col-4">
          <label class="w-65-mbl lbl_pos_field">{{'MENU_ITEM.ACTION' | translate}}</label>
        </div>
      </div>
    </div>
    <div class="row col-12 p-b-10-mbl" *ngFor="let supply of addOrEditMenuItemModel.supplies">
      <div class="col-6 mb-3">
        <input type="text" class="primary_input_field" [(ngModel)]="supply.supply.name" disabled="true">
      </div>
      <div class="col-12 col-sm-6 row p-b-10-mbl">
        <div class="col-4">
          <input type="number" step="1" min="0" class="primary_input_field w-75"
                 [(ngModel)]="supply.quantity">
        </div>
        <div class="col-4 pt-035rem">
          <span class="w-75 fw-bold">
            {{supply.supply.unitOfMeasurementShortName}}
          </span>
        </div>
        <div class="col-4 pt-1">
          <button class="btn-remove-supply" (click)="removeIngredient(supply)"><i
            class="pi pi-times"></i></button>
        </div>
      </div>
    </div>
  </div>

  <div class="row col-12 p-b-10-mbl" *ngFor="let particular of particulars; index as i;trackBy: trackByFn">
    <div class="col-6 ">
      <p-autoComplete [delay]="300" class="primary_autocomplete_field" inputStyleClass="primary_input_field"
                      field="name" [(ngModel)]="particulars[i]" [suggestions]="inventoryItemsList"
                      (completeMethod)="loadInventoryItemsForCompany($event)"></p-autoComplete>
    </div>
    <div class="col-12 col-sm-6 row p-b-10-mbl">
      <div class="col-4">
        <input *ngIf="inventoryItemsList.length !=0 && particulars[i].id" type="number" value="0" step="1" min="0"
               class="primary_input_field w-75"
               [(ngModel)]="particulars[i].quantity">
      </div>
      <div class="col-4 pt-035rem">
            <span *ngIf="inventoryItemsList.length !=0 && particulars[i].id" class="w-75 fw-bold">
              {{getMeasurementUnit(inventoryItemsList, particulars[i].id)}}
            </span>
      </div>
      <div class="col-4 pt-1">
        <button *ngIf="!particulars[i].id" class="btn-remove-supply" (click)="pushIngrediantItem(i)"><i
          class="pi pi-plus"></i></button>
        <button *ngIf="inventoryItemsList.length != 0 && particulars[i].id" class="btn-add-supply"
                (click)="pushIngrediantItem(i)"><i class="pi pi-check"></i></button>
      </div>
    </div>
  </div>

  <div class="d-flex flex-row justify-content-between pb-2">
    <button *ngIf="!enableEdit" class="btn_login w-100" (click)="addMenuItem(addOrEditMenuItemModel)">{{ 'SAVE' |
      translate}}</button>
    <button *ngIf="enableEdit" class="btn_login w-100" (click)="editMenuItem(addOrEditMenuItemModel)">{{ 'SAVE' |
      translate}}</button>
  </div>
</div>
